import { render } from "./ui-crop-image.vue?vue&type=template&id=2e366140&ts=true"
import script from "./ui-crop-image.vue?vue&type=script&lang=ts"
export * from "./ui-crop-image.vue?vue&type=script&lang=ts"

import "./ui-crop-image.vue?vue&type=style&index=0&id=2e366140&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__